module.exports = __webpack_public_path__ + "img/5.96095fc8.png";